import {FETCH_EVENTO, FETCH_EVENTO_SUCCESS, FETCH_EVENTO_FAILURE} from '../actions/evento';

const INITIAL_STATE = {data: null, status: null, error: null, loading: false};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_EVENTO:
            return {...state, data: null, loading: true};
        case FETCH_EVENTO_SUCCESS:
            return {...state, data: action.payload, loading: false};
        case FETCH_EVENTO_FAILURE:
            return {...state, data: null, loading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/reducers/evento.js